export default "__VITE_ASSET__CqZwdgII__"